const buildDefaultSelection = function buildDefaultSelection() {
  let formTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let columnsByFormType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return formTypes.reduce((acc, formType) => {
    const columns = (columnsByFormType === null || columnsByFormType === void 0 ? void 0 : columnsByFormType[formType.formTypeIdentifier]) || formType.columns || [];
    acc[formType.formTypeIdentifier] = columns.map(column => column.contentPath);
    return acc;
  }, {});
};
const buildPendingSelection = function buildPendingSelection() {
  let formTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return formTypes.reduce((acc, formType) => {
    acc[formType.formTypeIdentifier] = [];
    return acc;
  }, {});
};
export { buildPendingSelection };
export default buildDefaultSelection;